import { Link } from 'react-router-dom';

const cities = [
  { name: 'Tampa', county: 'Hillsborough', href: '/locations/tampa' },
  { name: 'St. Petersburg', county: 'Pinellas', href: '/locations/st-petersburg' },
  { name: 'Clearwater', county: 'Pinellas', href: '/locations/clearwater' },
  { name: 'Tarpon Springs', county: 'Pinellas', href: '/locations/tarpon-springs' },
  { name: 'Largo', county: 'Pinellas', href: '/locations/clearwater' },
  { name: 'Dunedin', county: 'Pinellas', href: '/locations/clearwater' },
  { name: 'Safety Harbor', county: 'Pinellas', href: '/locations/clearwater' },
  { name: 'Palm Harbor', county: 'Pinellas', href: '/locations/tarpon-springs' },
  { name: 'New Port Richey', county: 'Pasco', href: '/locations/tarpon-springs' },
  { name: 'Seminole', county: 'Pinellas', href: '/locations/clearwater' },
  { name: 'Pinellas Park', county: 'Pinellas', href: '/locations/st-petersburg' },
  { name: 'Temple Terrace', county: 'Hillsborough', href: '/locations/tampa' },
];

export default function ServiceAreas() {
  return (
    <section className="py-24 bg-parkside-cream">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 items-start">
          {/* Left content */}
          <div className="lg:col-span-2">
            <span className="inline-block bg-parkside-green/12 text-parkside-green text-xs font-bold uppercase tracking-widest px-3.5 py-1.5 rounded-full mb-4">
              Where We Work
            </span>
            <h2 className="font-display text-4xl md:text-5xl text-parkside-dark mb-4 tracking-display leading-tight">
              Areas We Serve
            </h2>
            <p className="text-parkside-muted text-base leading-relaxed mb-6">
              Parkside Pavers proudly serves homeowners and businesses throughout the greater Tampa Bay area. Expert paver installation in Tampa, patio design in Clearwater, driveway pavers near St. Petersburg — and everywhere in between.
            </p>

            {/* City grid */}
            <div className="flex flex-wrap gap-2 mb-7">
              {cities.map((city) => (
                <Link
                  key={city.name}
                  to={city.href}
                  className="group flex items-center gap-1.5 bg-white border border-stone-200 text-parkside-dark text-sm font-semibold px-3.5 py-2 rounded-lg hover:border-parkside-green/40 hover:bg-parkside-green/5 hover:text-parkside-green transition-all whitespace-nowrap cursor-pointer"
                >
                  <span className="w-3 h-3 inline-flex items-center justify-center">
                    <i className="ri-map-pin-fill text-parkside-amber text-xs" />
                  </span>
                  {city.name}
                </Link>
              ))}
            </div>

            <div className="flex flex-col gap-3">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 bg-parkside-green text-white font-bold px-6 py-3.5 rounded-xl hover:bg-parkside-greenDark transition-all whitespace-nowrap cursor-pointer"
              >
                Check If We Serve Your Area
                <span className="w-4 h-4 inline-flex items-center justify-center">
                  <i className="ri-arrow-right-line" />
                </span>
              </Link>
              <a
                href="tel:813-404-6313"
                className="inline-flex items-center justify-center gap-2 border border-parkside-green/30 text-parkside-green font-semibold px-6 py-3.5 rounded-xl hover:bg-parkside-green/8 transition-all whitespace-nowrap cursor-pointer text-sm"
              >
                <span className="w-4 h-4 inline-flex items-center justify-center">
                  <i className="ri-phone-fill" />
                </span>
                Call (813) 404-6313
              </a>
            </div>
          </div>

          {/* Map */}
          <div className="lg:col-span-3">
            <div className="rounded-2xl overflow-hidden border border-stone-200 h-[460px] relative">
              <iframe
                title="Parkside Pavers Service Area — Tampa Bay, FL"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d225892.78174516565!2d-82.67835599999999!3d27.994402!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c2b782b3b9d1e1%3A0xa75f605293570f50!2sTampa%20Bay%2C%20FL!5e0!3m2!1sen!2sus!4v1699000000000!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
              {/* Map overlay label */}
              <div className="absolute top-4 left-4 bg-white rounded-xl px-4 py-2.5 border border-stone-100">
                <div className="flex items-center gap-2">
                  <div className="w-7 h-7 flex items-center justify-center bg-parkside-green rounded-lg">
                    <i className="ri-map-pin-fill text-white text-sm" />
                  </div>
                  <div>
                    <p className="text-parkside-dark font-bold text-xs">Parkside Pavers</p>
                    <p className="text-parkside-stone text-[11px]">Tampa Bay Service Area</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
